import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.anchor.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import { createRichTextLinksMap } from '~/composables/useParseDocumentToHtml/HTMLParserOptions';
import { useAdviceStore } from '~/composables/_next/stores/useAdviceStore';
import { useSlugify } from '~/composables/useSlugify';
import { useSegment } from '~/composables/_next/useSegment';
import { cacheControl } from '~/helpers/cacheControl';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import AzImg from '~/components/Atoms/AzImg.vue';
import TheBibliography from '~/components/ui/TheBibliography.vue';
import BaseSingleBreadcrumb from '~/components/Layout/BaseSingleBreadcrumb.vue';
import BaseBreadcrumbs from '~/components/Layout/BaseBreadcrumbs.vue';
import BlockAdviceList from '~/components/cms/custom/BlockAdviceList.vue';
import BlockSummaryNav from '~/components/cms/custom/BlockSummaryNav.vue';
import RenderContent from '~/components/cms/page/RenderContent.vue';
import RichText from '~/components/ui/RichText.vue';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useLocalization } from '~/composables/_next/useLocalization';
const __nuxt_page_meta = {
  middleware: [cacheControl('public, s-maxage=7200, stale-while-revalidate=3600, stale-if-error=3600') // 2 hours cache and 1 hour stale
      ],tracking: {
        category: TrackingPageCategory.ADP
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: '_slug',
  setup: function setup(__props) {
    var SlimRelatedProductsCarousel = function SlimRelatedProductsCarousel() {
      return import('~/components/Organisms/SlimRelatedProducts.vue');
    };
    var RelatedRecipesOrganism = function RelatedRecipesOrganism() {
      return import('~/components/_next/organisms/RelatedRecipesOrganism.vue');
    };
    var RelatedAdvicesOrganism = function RelatedAdvicesOrganism() {
      return import('~/components/_next/organisms/RelatedAdvicesOrganism.vue');
    };
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n,
      error = _useNuxt2App.error,
      $trackers = _useNuxt2App.$trackers,
      app = _useNuxt2App.app;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useSlugify = useSlugify(),
      slugify = _useSlugify.slugify;
    ;

    // TODO: Remove after Nuxt 3 migration
    onMounted(function () {
      var _useSegment = useSegment(),
        analytics = _useSegment.analytics;
      analytics.page(TrackingPageCategory.ADP, PageTypes.ADP, {
        path: route.fullPath
      });
    });
    var _useAdviceStore = useAdviceStore(),
      fetchAllAdviceContent = _useAdviceStore.fetchAllAdviceContent,
      advice = _useAdviceStore.advice,
      relatedAdvices = _useAdviceStore.relatedAdvices,
      relatedRecipes = _useAdviceStore.relatedRecipes,
      relatedProducts = _useAdviceStore.relatedProducts,
      isFlattened = _useAdviceStore.isFlattened,
      components = _useAdviceStore.components;
    var _useLazyAsyncData = useLazyAsyncData("fetch-advice-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchAllAdviceContent();
            case 3:
              return _context.abrupt("return", true);
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              error({
                statusCode: 404
              });
              return _context.abrupt("return", false);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }))),
      status = _useLazyAsyncData.status;
    var breadcrumbs = computed(function () {
      var _advice$value, _advice$value$parentA, _advice$value2, _advice$value2$parent, _advice$value3;
      var crumbs = [{
        link: app.localePath({
          name: 'index'
        }),
        text: i18n.t('utils.homeBreadcrumbs')
      }, {
        link: app.localePath({
          name: 'pages-slug',
          params: {
            slug: (_advice$value = advice.value) === null || _advice$value === void 0 ? void 0 : (_advice$value$parentA = _advice$value.parentAdviceListingPage) === null || _advice$value$parentA === void 0 ? void 0 : _advice$value$parentA.slug
          }
        }),
        text: (_advice$value2 = advice.value) === null || _advice$value2 === void 0 ? void 0 : (_advice$value2$parent = _advice$value2.parentAdviceListingPage) === null || _advice$value2$parent === void 0 ? void 0 : _advice$value2$parent.title
      }, {
        link: app.localePath({
          name: 'page-slug',
          params: {
            slug: route.params.slug
          }
        }),
        text: (_advice$value3 = advice.value) === null || _advice$value3 === void 0 ? void 0 : _advice$value3.title
      }];
      return crumbs.filter(function (_ref2) {
        var text = _ref2.text;
        return text;
      });
    });
    var summary = computed(function () {
      if (isFlattened.value) {
        var _components$value;
        return ((_components$value = components.value) === null || _components$value === void 0 ? void 0 : _components$value.map(function (_ref3) {
          var fields = _ref3.fields;
          return {
            anchor: slugify(fields === null || fields === void 0 ? void 0 : fields.internalName),
            summaryTitle: fields.summaryTitle,
            title: fields.title,
            level: fields.level,
            component: fields.component
          };
        }).filter(function (_ref4) {
          var anchor = _ref4.anchor,
            summaryTitle = _ref4.summaryTitle,
            title = _ref4.title,
            level = _ref4.level,
            component = _ref4.component;
          if (anchor && anchor.length && (['BlockBlockList', 'BlockFullText'].includes(component) || level === 2)) {
            var titleStr = summaryTitle || title;
            return titleStr && titleStr.trim().length > 0;
          }
          return false;
        })) || [];
      } else {
        var _components$value2;
        return ((_components$value2 = components.value) === null || _components$value2 === void 0 ? void 0 : _components$value2.map(function (_ref5) {
          var fields = _ref5.fields;
          return {
            anchor: slugify(fields === null || fields === void 0 ? void 0 : fields.internalName),
            summaryTitle: fields.summaryTitle,
            title: fields.title
          };
        }).filter(function (_ref6) {
          var anchor = _ref6.anchor,
            summaryTitle = _ref6.summaryTitle,
            title = _ref6.title;
          if (anchor && anchor.length) {
            var titleStr = summaryTitle || title;
            return titleStr && titleStr.trim().length > 0;
          }
          return false;
        })) || [];
      }
    });

    // Used to customize the BlockImageTextList block within the
    // advice's dynamic content
    provide('isInPageAdvice', true);
    var readingTime = computed(function () {
      var _advice$value$wordCou, _advice$value4;
      var wordsPerMin = 250;
      var time = ((_advice$value$wordCou = (_advice$value4 = advice.value) === null || _advice$value4 === void 0 ? void 0 : _advice$value4.wordCount) !== null && _advice$value$wordCou !== void 0 ? _advice$value$wordCou : 0) / wordsPerMin;
      var roundedTime = Math.ceil(time);
      return roundedTime <= 4 ? roundedTime : '+4';
    });
    onMounted(function () {
      setDynamicYieldContext('OTHER', ['Advice_Page']);
    });
    setDynamicYieldContextSSR('OTHER', ['Advice_Page']);
    return {
      __sfc: true,
      SlimRelatedProductsCarousel: SlimRelatedProductsCarousel,
      RelatedRecipesOrganism: RelatedRecipesOrganism,
      RelatedAdvicesOrganism: RelatedAdvicesOrganism,
      setDynamicYieldContext: setDynamicYieldContext,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      route: route,
      i18n: i18n,
      error: error,
      $trackers: $trackers,
      app: app,
      locale: locale,
      slugify: slugify,
      fetchAllAdviceContent: fetchAllAdviceContent,
      advice: advice,
      relatedAdvices: relatedAdvices,
      relatedRecipes: relatedRecipes,
      relatedProducts: relatedProducts,
      isFlattened: isFlattened,
      components: components,
      status: status,
      breadcrumbs: breadcrumbs,
      summary: summary,
      readingTime: readingTime,
      AzBackToTopButton: AzBackToTopButton,
      createRichTextLinksMap: createRichTextLinksMap,
      AzImg: AzImg,
      TheBibliography: TheBibliography,
      BaseSingleBreadcrumb: BaseSingleBreadcrumb,
      BaseBreadcrumbs: BaseBreadcrumbs,
      BlockAdviceList: BlockAdviceList,
      BlockSummaryNav: BlockSummaryNav,
      RenderContent: RenderContent,
      RichText: RichText,
      AzLoader: AzLoader
    };
  }
});